import React, { useContext } from 'react';
import './Intro.scss';
import PublicImage from 'src/common/components/PublicImage';
import { layoutContext } from '../../CloudPakForAiops';
import { Scenario } from '../../../data/constants';

const Intro = ({ copy }: any) => {
  copy = copy.steps.intro;

  const { setCurrentScenario } = useContext(layoutContext);

  return (
    <>
      <div className="cloud-pak-for-aiops_intro-modal-wrapper">
        <div className="cloud-pak-for-aiops_intro-modal-image">
          <PublicImage
            imgPath={copy.image.src}
            widgetId="cloud-pak-for-aiops"
            alt={copy.image.alt}
          />
        </div>
        <div className="cloud-pak-for-aiops_intro-modal-text">
          <h2>{copy.title}</h2>
          <p>{copy.description}</p>

          <button
            className="cloud-pak-for-aiops_intro-modal-cta"
            onClick={() => setCurrentScenario(Scenario.profile)}
          >
            {copy.cta}
          </button>
        </div>
      </div>
    </>
  );
};

export default Intro;
